import React from "react";

import { MessageBox } from "capitalrx-components";
import { TestClaimFormattedAdditionalMessage, TestClaimFormattedAdditionalMessages } from "@/types/appTypes/transmissions";

const ResponseMessagesSegment: React.FC<TestClaimFormattedAdditionalMessages> = (props: TestClaimFormattedAdditionalMessages) => {
  const { title, additionalMessages } = props;

  if (!additionalMessages || (additionalMessages && additionalMessages.length === 0)) {
    return null;
  }

  let hasDuplicateMessage = false;
  for (const additionalMessage of additionalMessages) {
    if (additionalMessage.message && /duplicate of auth/i.test(additionalMessage.message)) {
      hasDuplicateMessage = true;
    }
  }

  let duplicateMessage;
  if (hasDuplicateMessage) {
    duplicateMessage = <MessageBox
      message="NOTE: This is a duplicate. If this is just a test claim, consider removing the 'Rx Number' above to avoid this claim being treated as a duplicate."
      type="warning"
      testId="test__response-messages-segment"
      extraClasses="test-claim-message caprx-h-bold-text"
      shadow={false}
      alignText="left"
    />;
  }

  return (
    <div className="response-segment" data-testid="test__response-segment">
      <div className="segment-name" data-testid="test__segment-name-messages">
        {title}
      </div>
      <div>
        {duplicateMessage}
        {additionalMessages.map(({ message }: TestClaimFormattedAdditionalMessage, index) => (
          <div key={index + message.slice(0, 10)}>
            <MessageBox
              message={message}
              type="warning"
              testId="test__response-messages-segment"
              extraClasses="test-claim-message caprx-h-bold-text"
              shadow={false}
              alignText="left"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResponseMessagesSegment;
